<template>
  <div style="position: absolute;">
    <img
      v-lazy="{
        src: profile,
        error: onError(),
        loading: require('@/assets/Rolling-1s-200px_2.svg')
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'teacherProfile',
  props: ['profile'],
  data() {
    return {
      manPhoto: require('../../../../../assets/staff-default-man.png')
    }
  },
  methods: {
    onError() {
      if (event !== undefined) {
        event.target.src = this.manPhoto
      }
    }
  }
}
</script>

<style lang="css" scoped>
img {
  width: 100px;
  border-radius: 103px;
  padding: 3px;
  object-fit: cover;
  height: 100px;
  object-position: top;
  border: 1px solid #abefff;
  background: #fff7f7;
  top: -84px;
  position: relative;
  left: 47px;
}
</style>
